<!--
  --
  -- ログインしているときのアクションコンポーネント
  --
  -->
<template>
  <v-menu
    offset-y
  >
    <!-- モバイル用ボタン -->
    <template #activator="{on}" v-if="$vuetify.breakpoint.xsOnly">
      <v-btn icon color="primary" v-on="on">
        <v-icon>person</v-icon>
      </v-btn>
    </template>

    <!-- タブレット & PC 用ボタン -->
    <template v-else #activator="{on}">
      <v-btn class="px-1 ml-4" text v-on="on">{{userName}} さん</v-btn>
    </template>

    <v-list dense>
      <!-- ユーザの制約 -->
      <template v-if="showLimited">
        <c-limited-sheet :limited="limited"/>
        <v-divider/>
      </template>

      <!-- ユーザメニュー -->
      <v-list-item :to="{name: 'my/books'}">
        <v-list-item-title>予約履歴</v-list-item-title>
      </v-list-item>
      <v-list-item :to="{name: 'my/account'}">
        <v-list-item-title>アカウント情報</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="env.payment" :to="{name: 'my/payment'}">
        <v-list-item-title>お支払い方法</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="env.optins" :to="{name: 'my/optins'}">
        <v-list-item-title>情報配信サービス</v-list-item-title>
      </v-list-item>

      <v-divider/>

      <!-- ログアウト -->
      <v-list-item @click="onLogout">
        <v-list-item-title>ログアウト</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import CLimitedSheet from './CLimitedSheet'

import * as C from '@/consts'
import { run } from '@/libs/a'
import * as time from '@/libs/time'

export default {
  name: 'CUserMenu',
  components: {
    CLimitedSheet
  },
  data: () => ({
    today: time.today()
  }),
  computed: {
    userName () {
      return this.getters['user/name']
    },
    limited () {
      const userMenuLimited = this.getters['org/userMenuLimited']
      if (userMenuLimited === 1) {
        return {
          beginner: false,
          minor: false,
          at: false,
          firstTime: false
        }
      }
      return this.getters['user/limited'](this.today)
    },
    showLimited () {
      return this.limited.beginner || this.limited.minor || this.limited.at || this.limited.firstTime
    },

    env () {
      const env = {
        payment: false,
        optins: false
      }

      const methods = this.getters['org/paymentMethods'] || []
      env.payment = (methods.findIndex(method => method !== C.PAY_SPOT) >= 0)
      env.optins = this.getters['org/optins']

      return env
    }
  },
  methods: {
    onLogout () {
      run(async () => {
        // ログイン情報をクリアする
        await this.dispatch('user/clear', true)

        // org のトップページに移動する
        // const route = this.getters['org/topRoute']
        // if (route.name === this.$route.name) {
        //   return
        // }
        // await this.goTo(route)
        const url = this.getters['org/topURL']
        window.location.href = url
      })
    }
  }
}
</script>
